import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-3" }
const _hoisted_2 = { class: "row mb-3" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "col-lg-4 col-md-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary mx-4" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "my-3" }, "Submitted Proposals"),
  /*#__PURE__*/_createElementVNode("i", { class: "ml-4 bi bi-triangle-fill up" }),
  /*#__PURE__*/_createTextVNode(" 1100k ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSelect = _resolveComponent("BaseSelect")!
  const _component_BaseSearch = _resolveComponent("BaseSearch")!
  const _component_Nav = _resolveComponent("Nav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_highcharts = _resolveComponent("highcharts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseSelect, { selectType: _ctx.programAreaProp }, null, 8, ["selectType"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BaseSearch)
      ])
    ]),
    _createVNode(_component_Nav, { navLink: _ctx.navLink }, null, 8, ["navLink"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_highcharts, { options: _ctx.chartOptions }, null, 8, ["options"])
      ])
    ])
  ]))
}